import styled from '../../../../../styles/theme';
import NeedHelpSectionStyled from '../../NeedHelpSectionStyled';
import { rem } from 'polished';

const NeedHelpSectionStyledOV_GB = styled(NeedHelpSectionStyled)`
    padding: ${rem('20px')} ${rem('10px')} ${rem('5px')} ${rem('10px')};
    background: ${({ theme }) => theme.colors.white};

    .need-help-section__link {
        color: ${({ theme }) => theme.colors.secondary} !important;
        margin: ${rem('5px')} 0 !important;
        &.need-help-section__phone {
            margin: -18px 0px;
        }
        &.need-help-section__faq {
            margin: -16px 0px;
        }
    }
    .need-help-section__text {
        margin: 0 !important;
    }

    .icon-wrapper {
        height: ${rem('15px')} !important;

        svg {
            path {
                fill: ${({ theme }) => theme.colors.primary} !important;
            }
        }
    }
`;

export default NeedHelpSectionStyledOV_GB;
